export default __webpack_public_path__ + "static/media/flask.ecaa1d08.svg";